import React, { createContext, useContext, useState, useEffect } from 'react';
import HttpApis from './services/HttpApis';
import { applyTheme } from './theme/applyTheme';

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  // Apply env/default brand color immediately so the UI is themed
  // before the /v1/config network call resolves (avoids a color flash).
  useEffect(() => {
    applyTheme(null);
  }, []);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await HttpApis.getConfig();
        if (response.data.status && response.data.data) {
          setConfig(response.data.data);
          // Re-theme from the per-tenant config returned by the API.
          applyTheme(response.data.data);
        } else {
          // Settle to defaults so consumers waiting on `config !== null`
          // (e.g. the player's fetch effects) don't wait forever.
          setConfig({});
        }
      } catch (err) {
        console.error(err);
        setConfig({});
      }
    };
    fetchConfig();
  }, []);

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  return useContext(ConfigContext);
};